import {
    PUSH_LIKED_USERS,
    CLEAR_LIKED_USERS,
    UPDATE_LIKED_USER
} from "@/store/mutations.type"

const StateKey = 'likedUsers'

export default {
    [CLEAR_LIKED_USERS](state) {
        state[StateKey] = []
        state[`${StateKey}Offset`] = 0
        state[`${StateKey}FetchCompleted`] = false
    },

    [PUSH_LIKED_USERS](state, users) {
        if (users.length) {
            users.forEach((user) => {
                if (user) state[StateKey].push(user)
            })
        }
        if (users.length === state[`${StateKey}Limit`]) {
            state[`${StateKey}Offset`] += state[`${StateKey}Limit`]
        } else {
            state[`${StateKey}FetchCompleted`] = true
        }
    },

    [UPDATE_LIKED_USER](state, payload) {
        const user = state[StateKey].find(user => user.id === payload.userId)
        if(user) Object.assign(user, payload.value)
    }
}